<template>

  <div class="renderPage fce-container" :class="{ 'theme--dark': $vuetify.theme.dark }">

    <!-- TOOLBAR CABECERA -->
    <v-toolbar flat height="56" :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="fce-toolbar px-2">
      <v-icon class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-file-document-edit-outline</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase fce-toolbar-title" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-4'">
        Facturas de Compras
      </v-toolbar-title>
      <v-spacer />
      <v-btn depressed color="primary" class="fce-btn font-weight-bold" @click="validarLicencia()">
        <v-icon left small>mdi-plus</v-icon> Nueva Factura de Compra
      </v-btn>
    </v-toolbar>

    <!-- TABLA -->
    <v-card flat class="fce-table-card mx-0" :color="$vuetify.theme.dark ? '#0f172a' : 'white'">
      <v-toolbar flat height="auto" :color="$vuetify.theme.dark ? '#0f172a' : 'white'" class="px-3 pt-2 pb-3">
        <v-row dense align="center">
          <v-col cols="12" sm="4" md="3">
            <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="dates" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="datesFormat"
                  label="Rango de fechas"
                  prepend-inner-icon="mdi-calendar"
                  readonly outlined dense hide-details
                  class="fce-search"
                  v-bind="attrs" v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" range scrollable color="primary">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateModal = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(dates); setDatesFormat(); getData();">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar por proveedor, código o estado..."
              single-line hide-details outlined dense
              class="fce-search"
            ></v-text-field>
          </v-col>
          <v-spacer />
          <v-btn icon :color="$vuetify.theme.dark ? 'blue-grey lighten-2' : 'grey darken-1'" @click="getData()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-row>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="fce-table"
        :loading="loading"
        @click:row="editItem"
        style="cursor:pointer"
      >
        <template v-slot:[`item.estadoHacienda`]="{ item }">
          <v-chip small :color="getEstadoColor(item.estadoHacienda)" class="font-weight-bold" text-color="white">
            {{ item.estadoHacienda }}
          </v-chip>
        </template>

        <template v-slot:[`item.totalComprobante`]="{ item }">
          <span class="font-weight-bold">{{ (item.totalComprobante || 0).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' }) }}</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn color="blue-grey darken-2" depressed dark style="min-width:36px;height:36px;padding:0;border-radius:4px" @click.stop="editItem(item)">
            <v-icon size="18">mdi-eye-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <div class="pa-8 text-center">
            <v-icon size="48" :color="$vuetify.theme.dark ? 'blue-grey darken-1' : 'grey lighten-1'" class="mb-3">mdi-file-document-outline</v-icon>
            <p :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">No se encontraron facturas en este periodo.</p>
            <v-btn color="primary" depressed small @click="getData()">Reintentar</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- FORM DRAWER - "SUPER DRAWER" PARA FACTURACIÓN -->
    <v-navigation-drawer
      v-model="drawerForm"
      fixed right temporary
      :width="$vuetify.breakpoint.mdAndUp ? 'calc(100% - 290px)' : '100%'"
      class="fce-drawer"
      stateless
    >
      <div class="d-flex flex-column fill-height">
        <!-- HEADER DEL DRAWER -->
        <div class="fce-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'fce-drawer-header--dark' : ''">
          <v-icon color="white" class="mr-3">mdi-file-document-edit-outline</v-icon>
          <div>
            <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">
              {{ editedIndex === -1 ? 'Nueva Factura de Compra' : 'Detalles de Factura' }}
            </div>
            <div class="caption white--text" style="opacity:0.7">
              {{ editedItem.codigoFact ? 'Comprobante #' + editedItem.codigoFact : 'Generando nuevo documento...' }}
              <v-chip v-if="editedIndex > -1 && editedItem.estadoHacienda" x-small dark outlined class="ml-2 font-weight-black" style="height:18px">
                {{ editedItem.estadoHacienda }}
              </v-chip>
            </div>
          </div>
          <v-spacer />
          <v-btn icon dark small @click="cerrar()"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <!-- CONTENIDO DEL DRAWER -->
        <div class="flex-grow-1 overflow-y-auto px-2 py-2 bg-light">
          <v-form v-model="valid" ref="form">
            <v-expansion-panels v-model="activePanels" multiple class="modern-panels">
              
              <!-- SECCIÓN 1: SELECCIÓN DE CLIENTE -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-truck-delivery-outline</v-icon>
                  Información del Proveedor
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-text-field
                        label="# Código Proveedor"
                        v-model="editedItem.clienteCod"
                        outlined dense hide-details
                        @input="iconVisible = true"
                        :disabled="!incluirValid"
                      >
                        <template v-slot:append>
                          <v-icon color="primary" @click="BuscarClienteCodigo" v-if="iconVisible && incluirValid">mdi-magnify</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Cédula / Identificación"
                        v-model="editedItem.clienteCedula"
                        outlined dense hide-details
                        @input="iconVisibleCedula = true"
                        :disabled="!incluirValid"
                      >
                        <template v-slot:append>
                          <v-icon color="primary" @click="BuscarClienteCedula" v-if="iconVisibleCedula && incluirValid">mdi-magnify</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="text-center">
                      <v-btn color="primary" icon large @click="mostrarBuscarProveedores" :disabled="!btnAgregarCliente">
                        <v-icon>mdi-account-plus</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field
                        v-model="editedItem.clienteNombre"
                        label="Nombre Completo"
                        outlined dense hide-details
                        readonly
                        placeholder="Seleccione un cliente..."
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="actividadesCliente.length > 0">
                      <v-select
                        v-model="editedItem.clienteCodigoActividad"
                        :items="actividadesCliente"
                        item-text="descripcion"
                        item-value="codigo"
                        label="Actividad Económica del Receptor"
                        outlined dense hide-details
                        prepend-inner-icon="mdi-briefcase-outline"
                        :disabled="!incluirValid"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- SECCIÓN 2: LÍNEAS DE DETALLE -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <div class="d-flex align-center w-100">
                    <v-icon color="primary" left class="mr-2">mdi-format-list-bulleted</v-icon>
                    Detalle de la Factura
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="btnAgregarArti"
                      color="success"
                      x-small
                     
                      outlined
                      @click.stop="mostrarBuscarArticulos"
                      class="mr-4 px-3"
                    >
                      <v-icon left size="16">mdi-cart-plus</v-icon>
                      Añadir Artículo
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-0">

                  <v-data-table
                    :headers="headersDetalle"
                    :items="lineasDetalle"
                    hide-default-footer
                    class="modern-table border-light rounded-lg overflow-hidden edit-table"
                    :items-per-page="-1"
                  >
                    <template v-slot:[`item.cantidad`]="{ item }">
                      <v-text-field
                        v-model.number="item.cantidad"
                        outlined hide-details
                        class="compact-input"
                        @input="recalcularTotales"
                      ></v-text-field>
                    </template>
                    <template v-slot:[`item.montoStr`]="{ item }">
                      <span class="font-weight-medium text-subtitle-1">{{ item.montoStr || (item.monto || 0).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' }) }}</span>
                    </template>
                    <template v-slot:[`item.porcDescuento`]="{ item }">
                      <v-text-field
                        v-model.number="item.porcDescuento"
                        outlined hide-details
                        class="compact-input"
                        @input="recalcularTotales"
                      ></v-text-field>
                    </template>
                    <template v-slot:[`item.totalLineaStr`]="{ item }">
                      <span class="font-weight-medium text-subtitle-1">{{ item.totalLineaStr || ((item.cantidad || 0) * (item.monto || 0)).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' }) }}</span>
                    </template>
                    <template v-slot:[`item.edit`]="{ item }">
                      <v-btn icon small color="primary" @click="detalleEditItem(item)" v-if="guardarValid">
                        <v-icon small>mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                      <v-btn icon small color="error" @click="deleteItem(item)" v-if="guardarValid">
                        <v-icon small>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- SECCIÓN 3: RESUMEN Y TOTALES -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-calculator-variant-outline</v-icon>
                  Resumen de Totales
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-lg pa-2 bg-light border-light text-center">
                        <div class="caption grey--text mb-0">Subtotal</div>
                        <div class="text-body-2 font-weight-bold">{{ editedItem.subtotalStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-lg pa-2 bg-light border-light text-center">
                        <div class="caption grey--text mb-0">Descuentos</div>
                        <div class="text-body-2 font-weight-bold error--text">{{ editedItem.totalDescuentosStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-lg pa-2 bg-light border-light text-center">
                        <div class="caption grey--text mb-0">Impuestos</div>
                        <div class="text-body-2 font-weight-bold primary--text">{{ editedItem.totalImpuestoStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card flat class="rounded-lg pa-2 primary border-light text-center white--text shadow-primary">
                        <div class="caption opacity-80 mb-0">TOTAL FACTURA</div>
                        <div class="text-body-2 font-weight-black">{{ editedItem.totalComprobanteStr || '0.00' }}</div>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row class="mt-2 border-top-light pt-2" dense>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva1Str" label="IVA 1%" readonly outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva2Str" label="IVA 2%" readonly outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva4Str" label="IVA 4%" readonly outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="editedItem.totalIva13Str" label="IVA 13%" readonly outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                       <v-text-field v-model="editedItem.totalIVADevueltoStr" label="IVA Devuelto" readonly outlined dense hide-details class="right-input"></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- SECCIÓN 4: HACIENDA Y ACCIONES -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <div class="d-flex align-center" style="width:100%">
                    <v-icon color="primary" left class="mr-2">mdi-cloud-check-outline</v-icon>
                    Estado y Gestión Hacienda
                    <v-spacer></v-spacer>
                    <v-chip
                      v-if="editedItem.estadoHacienda"
                      :color="getEstadoColor(editedItem.estadoHacienda)"
                      dark x-small
                      class="font-weight-bold mr-2"
                    >
                      {{ editedItem.estadoHacienda }}
                    </v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense align="start">
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="editedItem.clavehacienda"
                        label="Clave de Comprobante"
                        readonly outlined dense hide-details
                        :background-color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex align-center">
                       <v-btn
                        color="primary"
                       
                        depressed
                        block
                        height="40"
                        @click="consultarEstadoHacienda"
                        :disabled="!consultarEstadoValid || visibleProgress"
                        :loading="visibleProgress"
                        class="font-weight-bold"
                      >
                        <v-icon left>mdi-sync</v-icon>
                        Consultar Estado
                      </v-btn>
                    </v-col>
                    <v-col cols="12" v-if="editedItem.estadoHacienda" class="mt-2">
                       <div class="d-flex align-center pa-2 rounded-lg bg-light border-light">
                         <v-icon :color="getEstadoColor(editedItem.estadoHacienda)" class="mr-2">mdi-information-outline</v-icon>
                         <span class="font-weight-bold mr-2">Estado:</span>
                         <v-chip dark small :color="getEstadoColor(editedItem.estadoHacienda)" class="font-weight-black">
                           {{ editedItem.estadoHacienda }}
                         </v-chip>
                       </div>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="editedItem.mensajeHacienda"
                        label="Respuesta de Hacienda"
                        readonly outlined rows="2"
                        class="mt-2"
                        hide-details
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row v-if="editedIndex > -1" class="border-top-light pt-4 px-2" justify="center">
                    <v-btn text color="primary" class="mx-2 rounded-pill pr-4" @click="imprimir" :disabled="!verPDF">
                      <v-icon left>mdi-file-pdf-box</v-icon> Ver PDF
                    </v-btn>
                    <v-btn text color="primary" class="mx-2 rounded-pill pr-4" @click="getXMLFirmado" :disabled="!verXMLFirmado">
                      <v-icon left>mdi-xml</v-icon> XML Enviado
                    </v-btn>
                    <v-btn text color="primary" class="mx-2 rounded-pill pr-4" @click="getXMLRespuesta" :disabled="!verXMLRespuesta">
                      <v-icon left>mdi-message-reply-text</v-icon> Respuesta XML
                    </v-btn>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- SECCIÓN 5: CONFIGURACIÓN ADICIONAL -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <v-icon color="primary" left class="mr-2">mdi-cog-outline</v-icon>
                  Parámetros de Emisión
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-select label="Moneda" v-model="editedItem.moneda" :items="monedas" item-text="md_nombre" item-value="md_codigo" @change="changeMonedas" outlined dense hide-details prepend-inner-icon="mdi-cash-multiple"></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="editedItem.tipoCambio" label="T. Cambio" type="number" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select label="Condición Venta" v-model="editedItem.condicionVenta" :items="condicionesVenta" item-text="descripcion" item-value="codigo" outlined dense hide-details></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select label="Medio de Pago" v-model="editedItem.medioPago" :items="mediosPago" item-text="descripcion" item-value="codigo" outlined dense hide-details></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="editedItem.codigoActividad"
                        :items="actividades"
                        item-text="descripcion"
                        item-value="codigo"
                        label="Actividad Económica del Emisor"
                        outlined dense hide-details
                        prepend-inner-icon="mdi-briefcase-outline"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="editedItem.ordenCompra" label="Orden de Compra #" outlined dense prepend-inner-icon="mdi-file-document-outline" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-file-input
                        label="Subir Certificado (opcional)"
                        outlined dense
                        prepend-inner-icon="mdi-certificate"
                        prepend-icon=""
                        @change="onImageChange"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea v-model="editedItem.observacion" label="Observaciones en factura" outlined rows="2" hide-details></v-textarea>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- SECCIÓN CONTINGENCIA -->
              <v-expansion-panel class="rounded-xl mb-0 elevation-0 border-light">
                <v-expansion-panel-header class="font-weight-bold primary--text">
                  <div class="d-flex align-center" style="width:100%">
                    <v-icon color="warning" left class="mr-2">mdi-alert-circle-outline</v-icon>
                    <span class="warning--text">Contingencia</span>
                    <v-chip x-small color="warning" outlined class="ml-3 font-weight-bold">Uso excepcional</v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="editedItem.contingenciaFact" label="N° Comprobante Físico" outlined dense prepend-inner-icon="mdi-file-alert-outline" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="editedItem.contingenciaFecha" label="Fecha Emisión Física" type="datetime-local" outlined dense prepend-inner-icon="mdi-calendar-clock" hide-details></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </div>

        <!-- FOOTER ACCIONES -->
        <div class="fce-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'fce-drawer-footer--dark' : ''">
          <v-btn v-if="reenviarValid" color="secondary" text class="fce-btn font-weight-bold" @click="reenviar">
            <v-icon left small>mdi-send-outline</v-icon> Reenviar
          </v-btn>
          <v-spacer />
          <v-btn text class="mr-3 font-weight-bold fce-btn" @click="cerrar()">Cancelar</v-btn>
          <v-btn color="primary" depressed class="px-8 font-weight-bold fce-btn" :loading="visibleProgress" @click="save" :disabled="!guardarValid">
            {{ editedIndex === -1 ? 'GENERAR FACTURA' : 'GUARDAR CAMBIOS' }}
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- VISOR DE DOCUMENTOS (PDF / XML) -->
    <v-dialog v-model="docViewerDialog" max-width="1100" eager>
      <v-card style="height: 88vh;" class="d-flex flex-column overflow-hidden rounded-xl">
        <div class="doc-viewer-toolbar d-flex align-center px-3 py-2 white--text flex-shrink-0">
          <v-icon color="white" size="18" class="mr-2">mdi-file-document-outline</v-icon>
          <span class="font-weight-bold text-subtitle-2">{{ docViewerTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon x-small dark class="mr-1" @click="abrirEnNuevaPestana" title="Abrir en nueva pestaña">
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn icon x-small dark @click="docViewerDialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
        <iframe v-if="docViewerDialog" :src="docViewerUrl" class="flex-grow-1" style="border: none; width: 100%;"></iframe>
      </v-card>
    </v-dialog>

    <!-- MODALES DE BÚSQUEDA (MODERNIZADOS) -->
    <v-dialog transition="dialog-bottom-transition" v-model="dialog" width="900" persistent>
      <div v-if="showNewData">
        <BuscarProveedores v-bind:allwedOnly="true" @clicked="selected" @closed="closed" />
      </div>
    </v-dialog>

    <v-dialog transition="dialog-bottom-transition" v-model="dialogBuscarArticulos" width="1000" persistent>
      <div v-if="showNewDataArti">
        <BuscarArticulos v-bind:allwedOnly="true" @clicked="selectedArticulos" @closed="closed" />
      </div>
    </v-dialog>

    <!-- MODAL DETALLE ARTÍCULO (TABLET-LIKE EDITOR) -->
    <v-dialog v-model="dialogArticulos" max-width="700px" persistent>
      <v-card flat class="overflow-hidden">
        <div class="fce-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'fce-drawer-header--dark' : ''">
           <v-icon color="white" class="mr-3">mdi-cart-edit</v-icon>
           <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">{{ formTitle }}</div>
           <v-spacer></v-spacer>
           <v-btn icon dark small @click="dialogArticulos = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-5 mt-1">
          <v-row dense>
            <v-col cols="12" md="4">
              <v-text-field v-model="detalleEditedItem.articulo" label="Código" outlined dense readonly hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field v-model="detalleEditedItem.descripcion" label="Descripción" outlined dense hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="detalleEditedItem.cantidad" label="Cantidad" type="number" outlined dense hide-details step="any" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="detalleEditedItem.monto" label="Precio Unit." type="number" outlined dense hide-details step="any" class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="detalleEditedItem.porcDescuento" label="% Descuento" type="number" outlined dense hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12">
               <v-text-field v-model="detalleEditedItem.cabys" label="Código CABYS" outlined dense readonly hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="detalleEditedItem.registroMedicamento" label="Reg. Medicamento" outlined dense hide-details class="mb-3"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select v-model="detalleEditedItem.formaFarmaceutica" :items="formas" item-text="descripcion" item-value="codigo" label="Forma Farmacéutica" outlined dense hide-details></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <div class="fce-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'fce-drawer-footer--dark' : ''">
          <v-spacer></v-spacer>
          <v-btn text class="mr-3 font-weight-bold fce-btn" @click="dialogArticulos = false">Cancelar</v-btn>
          <v-btn color="primary" depressed class="px-8 font-weight-bold fce-btn" @click="saveDetalleArticulo">Aceptar</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- OTROS DIALOGOS -->
    <!-- ELIMINADO DIALOG SINPE - NO APLICA PARA COMPRAS -->

    <!-- MODAL REENVÍO POR CORREO (SIMPLIFICADO) -->
    <v-dialog v-model="dialogFormaReenvio" max-width="500px">
      <v-card class="rounded-xl overflow-hidden">
        <div class="secondary pa-6 white--text d-flex align-center">
           <v-icon color="white" class="mr-3">mdi-email-send-outline</v-icon>
           <h3 class="text-h6 font-weight-bold">Reenviar Comprobante</h3>
           <v-spacer></v-spacer>
           <v-btn icon dark @click="dialogFormaReenvio = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-6 mt-4">
          <p class="body-1 mb-4">Confirme o edite el correo electrónico para el reenvío:</p>
          <v-text-field
            v-model="reenvioInfo.correo"
            label="Correo Electrónico"
            outlined
            dense
           
            prepend-inner-icon="mdi-email-outline"
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4 bg-light">
          <v-spacer></v-spacer>
          <v-btn text class="px-6" @click="dialogFormaReenvio = false">Cancelar</v-btn>
          <v-btn color="secondary" depressed class="px-8 font-weight-bold" @click="confirmarReenvio">
            Enviar Ahora
            <v-icon right small>mdi-send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card class="rounded-xl pa-2">
        <v-card-title class="text-h6 font-weight-bold">¿Eliminar línea?</v-card-title>
        <v-card-text class="body-1 py-4">¿Estás seguro de que deseas descartar este artículo de la factura?</v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn text class="px-6" @click="closeDelete">Cancelar</v-btn>
          <v-btn color="error" depressed class="px-6 font-weight-bold" @click="deleteItemConfirm">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";
import BuscarProveedores from "./BuscarProveedores.vue";
import BuscarArticulos from "./BuscarArticulos.vue";

export default {
  components: {
    Snackbar,
    BuscarProveedores,
    BuscarArticulos,
  },
  // dark: true,
  data() {
    return {
      drawerForm: false,
      activePanels: [0, 1],
      docViewerDialog: false,
      docViewerUrl: "",
      docViewerTitle: "",
      dialogBuscarArticulos: false,
      showNewDataArti: false,
      showNewData: false,
      btnAgregarCliente: false,
      btnAgregarArti: false,
      iconVisible: false,
      iconVisibleCedula: false,
      visibleBtnConsultar: true,
      visibleProgress: false,
      dialog: false,
      dialogArticulos: false,
      valid: false,
      incluirValid: true,
      consultarEstadoValid: false,
      cancelarValid: false,
      reenviarValid: false,
      imprimirValid: false,
      guardarValid: false,
      search: "",
      snackText: "",
      snackValue: false,
      tab2: 1,
      tabFactura: 0,
      dialogDelete: false,
      verPDF: false,
      verXMLFirmado: false,
      verXMLRespuesta: false,
      panel: [],
      dateModal: false,
      dates: [],
      datesFormat: [],
      panelResumen: [],
      headers: [
        { text: "Código", align: "start", value: "codigoFact" },
        { text: "Proveedor", align: "start", value: "clienteNombre" },
        { text: "Fecha", align: "start", value: "fechaString" },
        { text: "Clave Hacienda", align: "start", value: "clavehacienda" },
        { text: "Total", align: "end", value: "totalComprobanteStr" },
        { text: "Estado", align: "center", value: "estadoHacienda" },
        { text: "Acciones", value: "actions", sortable: false, align: "center" },
      ],
      headersDetalle: [
        { text: "Cant", align: "start", value: "cantidad" },
        { text: "Código", align: "start", value: "articulo" },
        { text: "Descripción", align: "start", value: "descripcion" },
        { text: "Unidad", align: "start", value: "unidad" },
        { text: "Precio", align: "start", value: "montoStr" },
        { text: "Total", align: "start", value: "totalLineaStr" },
        { text: "Editar", value: "edit", width: 50, sortable: false },
        { text: "Eliminar", value: "delete", width: 70, sortable: false },
      ],
      items: [],
      tiposIdentificacion: [],
      actividades: [],
      actividadesCliente: [],
      condicionesVenta: [],
      mediosPago: [],
      sucursales: [],
      terminales: [],
      monedas: [],
      provincias: [],
      cantones: [],
      distritos: [],
      barrios: [],
      cliente: [],
      articulo: [],
      totales: [],
      lineasDetalle: [],
      tipoCambio: [],
      respuestaHacienda: [],
      comprobante: [],
      editedIndex: -1,
      formas: [],
      pagoInfo: {},
      reenvioInfo: { correo: "" },
      dialogSinpe: false,
      dialogFormaReenvio: false,
      licenciaValida: { valido: true, motivo: "" },
      modelFactura: {
        comprobante: {},
        comprobanteDetalle: [],
      },
      defaultItem: {
        cia: "",
        codigoFact: "",
        tipoFact: "08",
        fecha: new Date().toISOString().slice(0, 10),
        tipoCambio: 1,
        clienteCod: "",
        clienteNombre: "",
        clienteCorreo: "",
        clienteCedula: "",
        clienteAreaTel: "",
        clienteTelefono: "",
        clienteNombreComercial: "",
        clienteProvincia: "",
        clienteCanton: "",
        clienteDistrito: "",
        clienteBarrio: "",
        clienteDireccion: "",
        clienteTipoId: "",
        clienteCodigoActividad: "",
        estadoHacienda: "PENDIENTE",
        moneda: "CRC",
        condicionVenta: "",
        medioPago: "",
        codigoActividad: "",
        totalComprobante: 0,
        nombreTabla: "FacturasCompras",
        contingenciaFact: "",
        contingenciaFecha: new Date(),
        subtotalStr: "0.00",
        totalDescuentosStr: "0.00",
        totalImpuestoStr: "0.00",
        totalComprobanteStr: "0.00",
      },
      detalleDefaultItem: {
        cia: "",
        factura: "",
        tipoFact: "08",
        cantidad: 1,
        articulo: "",
        descripcion: "",
        monto: 0,
        porcDescuento: 0,
        totalLinea: 0,
        sucursal: "",
        terminal: "",
        unidad: "",
        cabys: "",
        registroMedicamento: "",
        formaFarmaceutica: "",
      },
      editedItem: {
        cia: "",
        codigoFact: "",
        tipoFact: "08",
        fecha: new Date().toISOString().slice(0, 10),
        tipoCambio: 1,
        clienteCod: "",
        clienteNombre: "",
        clienteCorreo: "",
        clienteCedula: "",
        clienteAreaTel: "",
        clienteTelefono: "",
        clienteNombreComercial: "",
        clienteProvincia: "",
        clienteCanton: "",
        clienteDistrito: "",
        clienteBarrio: "",
        clienteDireccion: "",
        clienteTipoId: "",
        clienteCodigoActividad: "",
        estadoHacienda: "PENDIENTE",
        moneda: "CRC",
        condicionVenta: "",
        medioPago: "",
        codigoActividad: "",
        totalComprobante: 0,
        nombreTabla: "FacturasCompras",
        contingenciaFact: "",
        contingenciaFecha: new Date(),
        subtotalStr: "0.00",
        totalDescuentosStr: "0.00",
        totalImpuestoStr: "0.00",
        totalComprobanteStr: "0.00",
        mensajeHacienda: "",
        clavehacienda: "",
        totalIva1Str: "0.00",
        totalIva2Str: "0.00",
        totalIva4Str: "0.00",
        totalIva13Str: "0.00",
        totalIVADevueltoStr: "0.00",
        ordenCompra: "",
        observacion: "",
      },
      detalleEditedItem: {
        cia: "",
        factura: "",
        tipoFact: "08",
        cantidad: 1,
        articulo: "",
        descripcion: "",
        monto: 0,
        porcDescuento: 0,
        totalLinea: 0,
        sucursal: "",
        terminal: "",
        unidad: "",
        cabys: "",
        registroMedicamento: "",
        formaFarmaceutica: "",
      },
      detalleEditedIndex: -1,
      ciaItem: {},
      loading: false,
      nameRules: [(v) => !!v || "Campo requerido"],
      tempFile: "",
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
    formTitle() {
      return this.editedIndex === -1 ? "Agregar Articulo" : "Editar Articulo";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    dialogArticulos(val) {
      val || this.close();
    },

    search() {
      this.snackValue = false;
    },
  },

  created() {
    this.setDates();
    this.getData();
    this.getMonedas();
    this.getProvincias();
    this.getActividades();
    this.getCondicionVenta();
    this.getMedioPago();
  },

  methods: {
    getEstadoColor(estado) {
      if (!estado) return "grey";
      const e = estado.toUpperCase();
      if (e === "ACEPTADO") return "success";
      if (e === "RECHAZADO") return "error";
      if (e === "PROCESANDO") return "warning";
      if (e === "PENDIENTE") return "info";
      return "grey";
    },
    signalChange: function (evt) {
      this.snackText = "Si llega al escribir" + evt;
      this.snackValue = true;
    },

    changeText() {
      this.iconVisible = true;
    },

    activarIconoCedula() {
      this.iconVisibleCedula = true;
    },

    // getData() {
    //   let me = this;
    //   axios
    //     .get(
    //       "api/Facturacion/GetComprobantes?cia=" +
    //         this.strCia +
    //         "&docNombre=FacturasCompras&tipoDoc=08",
    //       {
    //         crossdomain: true,
    //       }
    //     )
    //     .then(function (response) {
    //       me.items = response.data;
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },

    getData() {
      if (!this.dates || this.dates.length < 2) return;
      let me = this;
      axios
        .get(
          "api/Facturacion/GetComprobantes?cia=" +
            this.strCia +
            "&docNombre=FacturasCompras&tipoDoc=08" +
            "&fechaInicio=" +
            this.dates[0].toString() +
            "&fechaFin=" +
            this.dates[1].toString(),
          {
            crossdomain: true,
          }
        )
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    setDates() {
      var date = new Date();
      var dateInicio = new Date(date.getFullYear(), date.getMonth(), 1);
      this.dates = [
        dateInicio.toISOString().substr(0, 10),
        date.toISOString().substr(0, 10)
      ];

      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var dt = date.getDate();

      if (dt < 10) {
        dt = "0" + dt;
      }
      if (month < 10) {
        month = "0" + month;
      }

      var yearInicio = dateInicio.getFullYear();
      var monthInicio = dateInicio.getMonth() + 1;
      var dtInicio = dateInicio.getDate();

      if (dtInicio < 10) {
        dtInicio = "0" + dtInicio;
      }
      if (monthInicio < 10) {
        monthInicio = "0" + monthInicio;
      }

      // this.snackText = "llega" + dt + '-' + month + '-' + year;
      // this.snackValue = true;

      this.datesFormat[0] = dtInicio + "-" + monthInicio + "-" + yearInicio;
      this.datesFormat[1] = dt + "-" + month + "-" + year;
    },

    setDatesFormat() {
      //eslint-disable-next-line
      var date = new Date(
        this.dates[0].toString().replace(/-/g, "/").replace(/T.+/, "")
      );

      //eslint-disable-next-line
      var date2 = new Date(
        this.dates[1].toString().replace(/-/g, "/").replace(/T.+/, "")
      );

      var year = date2.getFullYear();
      var month = date2.getMonth() + 1;
      var dt = date2.getDate();

      if (dt < 10) {
        dt = "0" + dt;
      }
      if (month < 10) {
        month = "0" + month;
      }

      var yearInicio = date.getFullYear();
      var monthInicio = date.getMonth() + 1;
      var dtInicio = date.getDate();

      if (dtInicio < 10) {
        dtInicio = "0" + dtInicio;
      }
      if (monthInicio < 10) {
        monthInicio = "0" + monthInicio;
      }

      // this.snackText = "llega antes de sumar" + this.dates[0] + "-" + this.dates[1] + "luego de sumar: " + dtInicio + '-' + monthInicio + '-' + yearInicio + "-" + dt + '-' + month + '-' + year;
      // this.snackValue = true;

      this.datesFormat[0] = dtInicio + "-" + monthInicio + "-" + yearInicio;
      this.datesFormat[1] = dt + "-" + month + "-" + year;
    },

    printDate: function () {
      return new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD format
    },

    getActividades() {
      let me = this;
      axios
        .get("api/General/getActividadesByCia?cia=" + this.strCia)
        .then(function (response) {
          me.actividades = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCondicionVenta() {
      let me = this;
      axios
        .get("api/General/getCondicionVenta")
        .then(function (response) {
          me.condicionesVenta = response.data;
          me.editedItem.condicionVenta = me.condicionesVenta[0]["codigo"];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getMedioPago() {
      let me = this;
      axios
        .get("api/General/getMediosPago")
        .then(function (response) {
          me.mediosPago = response.data;
          me.editedItem.medioPago = me.mediosPago[0]["codigo"];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCia() {
      let me = this;
      axios
        .get("api/Cias/getCia?ciaId=" + this.strCia)
        .then(function (response) {
          me.ciaItem = response.data;
          me.editedItem.emisorNombre = me.ciaItem.nombre;
          me.editedItem.emisorNombreComercial = me.ciaItem.nombreComercial;
          me.editedItem.codigoActividad = me.ciaItem.codigoActividad;
          me.editedItem.emisorTelefono = me.ciaItem.telefono;
          me.editedItem.emisorCorreo = me.ciaItem.correo;
          me.editedItem.emisorDireccion = me.ciaItem.direccion;
          me.editedItem.moneda = me.ciaItem.moneda;
          me.editedItem.cia = me.ciaItem.cedula;
          me.editedItem.fecha = me.printDate();

          me.getSucursales();
          me.getTerminales(me.ciaItem.sucursal);
          me.editedItem.sucursal = me.ciaItem.sucursal;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getSucursales() {
      let me = this;
      axios
        .get("api/Cias/getSucursalesByCia?cia=" + this.strCia)
        .then(function (response) {
          me.sucursales = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTerminales(sucursal) {
      let me = this;
      axios
        .get(
          "api/Cias/getTerminales?cia=" + this.strCia + "&sucursal=" + sucursal
        )
        .then(function (response) {
          me.terminales = response.data;
          me.editedItem.terminal = me.terminales[0]["terminalId"];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getBarrios() {
      let me = this;
      axios
        .get(
          "api/General/getBarrios?provincia=" +
            this.editedItem.clienteProvincia +
            "&canton=" +
            this.editedItem.clienteCanton +
            "&distrito=" +
            this.editedItem.clienteDistrito
        )
        .then(function (response) {
          me.barrios = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeDistritos() {
      this.getBarrios();
    },

    getDistritos() {
      let me = this;
      axios
        .get(
          "api/General/getDistritos?provincia=" +
            this.editedItem.clienteProvincia +
            "&canton=" +
            this.editedItem.clienteCanton
        )
        .then(function (response) {
          me.distritos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeCantones() {
      this.getDistritos();
    },

    getCantones() {
      let me = this;
      axios
        .get(
          "api/General/getCantones?provincia=" +
            this.editedItem.clienteProvincia
        )
        .then(function (response) {
          me.cantones = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeProvincia() {
      this.getCantones();
    },

    changeSucursal() {
      this.getTerminales();
    },

    getProvincias() {
      let me = this;
      axios
        .get("api/General/getProvincias")
        .then(function (response) {
          me.provincias = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getMonedas() {
      let me = this;
      axios
        .get("api/General/getMonedas")
        .then(function (response) {
          me.monedas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    BuscarClienteCodigo() {
      this.snackValue = false;
      let me = this;
      if (me.editedItem.clienteCod !== "") {
        me.showNewData = false;
        axios
          .get(
            "api/Proveedores/getProveedor?cia=" +
              this.strCia +
              "&codigo=" +
              this.editedItem.clienteCod
          )
          .then(function (response) {
            me.cliente = response.data;
            me.showNewData = false;
            me.dialog = false;
            me.dialogArticulos = false;
            me.editedItem.clienteCod = me.cliente.codigo;
            me.editedItem.clienteNombre = me.cliente.nombre;
            me.editedItem.clienteCorreo = me.cliente.correo;
            me.editedItem.clienteCedula = me.cliente.cedula;
            me.editedItem.clienteAreaTel = me.cliente.areaTel;
            me.editedItem.clienteTelefono = me.cliente.telefono;
            me.editedItem.clienteNombreComercial = me.cliente.nombreComercial;
            me.getProvincias();
            me.editedItem.clienteProvincia = me.cliente.provincia;
            me.getCantones();
            me.editedItem.clienteCanton = me.cliente.canton;
            me.getDistritos();
            me.editedItem.clienteDistrito = me.cliente.distrito;
            me.getBarrios();
            me.editedItem.clienteBarrio = me.cliente.barrio;
            me.editedItem.clienteDireccion = me.cliente.direccion;
            me.editedItem.clienteTipoId = me.cliente.tipoId;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    BuscarClienteCedula() {
      this.snackValue = false;
      let me = this;
      if (me.editedItem.clienteCedula !== "") {
        me.showNewData = false;
        axios
          .get(
            "api/Proveedores/getProveedor?cia=" +
              this.strCia +
              "&cedula=" +
              this.editedItem.clienteCedula
          )
          .then(function (response) {
            me.cliente = response.data;
            me.showNewData = false;
            me.dialog = false;
            me.dialogArticulos = false;
            me.editedItem.clienteCod = me.cliente.codigo;
            me.editedItem.clienteNombre = me.cliente.nombre;
            me.editedItem.clienteCorreo = me.cliente.correo;
            me.editedItem.clienteCedula = me.cliente.cedula;
            me.editedItem.clienteAreaTel = me.cliente.areaTel;
            me.editedItem.clienteTelefono = me.cliente.telefono;
            me.editedItem.clienteNombreComercial = me.cliente.nombreComercial;
            me.getProvincias();
            me.editedItem.clienteProvincia = me.cliente.provincia;
            me.getCantones();
            me.editedItem.clienteCanton = me.cliente.canton;
            me.getDistritos();
            me.editedItem.clienteDistrito = me.cliente.distrito;
            me.getBarrios();
            me.editedItem.clienteBarrio = me.cliente.barrio;
            me.editedItem.clienteDireccion = me.cliente.direccion;
            me.editedItem.clienteTipoId = me.cliente.tipoId;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    mostrarBuscarProveedores() {
      this.dialog = true;
      this.showNewData = true;
      this.cancelarValid = true;
    },

    mostrarBuscarArticulos() {
      this.dialogArticulos = false;
      this.dialogBuscarArticulos = true;
      this.showNewDataArti = true;
      this.cancelarValid = true;
    },

    getClienteHacienda() {
      let me = this;
      axios
        .get(
          "https://api.hacienda.go.cr/fe/ae?identificacion=" +
            me.editedItem.cedula
        )
        .then(function (response) {
          me.clienteHacienda = response.data;
          me.editedItem.nombre = me.clienteHacienda.nombre;
          me.editedItem.nombreComercial = me.clienteHacienda.nombre;
          me.editedItem.tipoId = me.clienteHacienda.tipoIdentificacion;

          if (me.clienteHacienda.situacion.estado === "Inscrito") {
            me.editedItem.esProd = true;
            me.editedItem.areaTel = "506";
          } else {
            me.editedItem.esProd = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeMonedas() {
      if (this.editedItem.moneda === "USD") {
        this.getTipoCambio();
      }
      if (this.editedItem.moneda === "CRC") {
        this.editedItem.tipoCambio = 0;
      }
    },

    getTipoCambio() {
      let me = this;
      axios
        .get(
          "https://apis.gometa.org/tdc/tdc.json?fbclid=IwAR0ye7K1k---y1DMcYsWN7AMSpQAB_LPTcbQnSDY72FrnffmeR_zfDfYiO4",
          { crossdomain: true }
        )
        .then(function (response) {
          me.tipoCambio = response.data;
          me.editedItem.tipoCambio = me.tipoCambio.venta;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editItem(item) {
      this.snackValue = false;
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.getModeloComprobante();
      this.editedItem.nombreTabla = "FacturasCompras";
      this.getCia();
      this.getMonedas();
      this.getActividades();
      this.getCondicionVenta();
      this.getMedioPago();
      this.getSucursales();
      this.changeProvincia();
      this.changeCantones();
      this.changeDistritos();
      this.tab2 = 1;

      // Expandir todos los paneles relevantes para edición
      this.drawerForm = true;
      this.activePanels = [0, 1, 2, 3, 4];
      
      this.updateUIVisibility();

      this.panel = [0];
      this.panelResumen = [0];
    },

    detalleEditItem(item) {
      if (this.guardarValid) {
        this.detalleEditedIndex = this.lineasDetalle.indexOf(item);
        this.detalleEditedItem = Object.assign({}, item);
        this.dialogArticulos = true;
      }
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.detalleEditedIndex = -1;
      });
    },

    deleteItemConfirm() {
      if (this.guardarValid) {
        this.lineasDetalle.splice(this.detalleEditedIndex, 1);
        this.closeDelete();

        let me = this;

        axios
          .post(
            "api/Facturacion/realizarCalculosComprobante",
            this.lineasDetalle
          )
          .then(function (response) {
            me.lineasDetalle = response.data.comprobanteDetalle;

            me.totales = response.data.comprobante;
            me.editedItem.totalIVADevuelto = 0; //validar esto
            me.editedItem.subTotal = me.totales.subtotal;
            me.editedItem.totalDescuentos = me.totales.totalDescuentos;
            me.editedItem.totalImpuesto = me.totales.totalImpuesto;
            me.editedItem.totalIva1 = me.totales.totalIva1;
            me.editedItem.totalIva2 = me.totales.totalIva2;
            me.editedItem.totalIva4 = me.totales.totalIva4;
            me.editedItem.totalIva13 = me.totales.totalIva13;
            me.editedItem.totalComprobante = me.totales.totalComprobante;

            me.editedItem.totalServGravados = me.totales.totalServGravados;
            me.editedItem.totalServExentos = me.totales.totalServExentos;
            me.editedItem.totalServExonerado = me.totales.totalServExonerado;
            me.editedItem.totalMercanciasGravadas =
              me.totales.totalMercanciasGravadas;
            me.editedItem.totalMercanciasExentas =
              me.totales.totalMercanciasExentas;
            me.editedItem.totalMercExonerada = me.totales.totalMercExonerada;
            me.editedItem.totalGravado = me.totales.totalGravado;
            me.editedItem.totalExento = me.totales.totalExento;
            me.editedItem.totalExonerado = me.totales.totalExonerado;
            me.editedItem.totalVenta = me.totales.totalVenta;
            me.editedItem.totalVentaNeta = me.totales.totalVentaNeta;
            me.editedItem.totalIVADevuelto = me.totales.totalIVADevuelto;
            me.editedItem.totalOtrosCargos = me.totales.totalOtrosCargos;
            me.editedItem.totalIva13 = me.totales.totalIva13;

            me.editedItem.totalIVADevueltoStr = me.totales.totalIVADevueltoStr; //validar esto
            me.editedItem.totalIva1Str = me.totales.totalIva1Str;
            me.editedItem.totalIva2Str = me.totales.totalIva2Str;
            me.editedItem.totalIva4Str = me.totales.totalIva4Str;
            me.editedItem.totalIva13Str = me.totales.totalIva13Str;
            me.editedItem.totalDescuentosStr = me.totales.totalDescuentosStr;
            me.editedItem.totalImpuestoStr = me.totales.totalImpuestoStr;
            me.editedItem.subtotalStr = me.totales.subtotalStr;
            me.editedItem.totalComprobanteStr = me.totales.totalComprobanteStr;
            //me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
      }
    },

    consultarEstadoHacienda() {
      this.snackValue = false;
      this.visibleProgress = true;
      let me = this;

      this.comprobante = this.editedItem;

      axios
        .post("api/Facturacion/obtenerRespuestaHacienda", this.comprobante)
        .then(function (response) {
          me.visibleProgress = false;
          me.respuestaHacienda = response.data;
          
          me.editedItem.estadoHacienda = me.respuestaHacienda.eInvoiceStatus;
          me.editedItem.mensajeHacienda = me.respuestaHacienda.details;
          
          me.updateUIVisibility();
          me.getData();
        })
        .catch(function (error) {
          me.visibleProgress = false;
          me.snackText = "Error al consultar estado";
          me.snackValue = true;
          console.log(error);
        });
    },

    reenviarCorreo() {
      this.snackValue = false;
      let me = this;

      this.comprobante = this.editedItem;

      axios
        .post("api/Facturacion/reenviarCorreo", this.comprobante)
        .then(function (response) {
          me.snackText = response.data;
          me.snackValue = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openDocViewer(url, title) {
      this.docViewerUrl = url;
      this.docViewerTitle = title;
      this.docViewerDialog = true;
    },

    abrirEnNuevaPestana() {
      if (this.docViewerUrl) {
        window.open(this.docViewerUrl, '_blank');
      }
    },

    imprimir() {
      const base = axios.defaults.baseURL || "";
      const url = `${base}/api/Facturacion/getFileContent?cia=${this.strCia}&clave=${this.editedItem.clavehacienda}&type=pdf`;
      this.openDocViewer(url, "PDF — Factura de Compra");
    },

    getXMLFirmado() {
      const base = axios.defaults.baseURL || "";
      const url = `${base}/api/Facturacion/getFileContent?cia=${this.strCia}&clave=${this.editedItem.clavehacienda}&type=signed`;
      this.openDocViewer(url, "XML Enviado — Factura de Compra");
    },

    getXMLRespuesta() {
      const base = axios.defaults.baseURL || "";
      const url = `${base}/api/Facturacion/getFileContent?cia=${this.strCia}&clave=${this.editedItem.clavehacienda}&type=response`;
      this.openDocViewer(url, "Respuesta de Hacienda — Factura de Compra");
    },

    getReport() { this.imprimir(); },

    getModeloComprobante() {
      let me = this;

      axios
        .get(
          "api/Facturacion/getModeloComprobante?cia=" +
            this.strCia +
            "&clave=" +
            this.editedItem.clavehacienda +
            "&docNombre=FacturasCompras"
        )
        .then(function (response) {
          me.modelFactura = response.data;

          me.editedItem = me.modelFactura.comprobante;
          me.lineasDetalle = me.modelFactura.comprobanteDetalle;
          me.fecha = me.editedItem.fechaString;
          me.updateUIVisibility();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    updateUIVisibility() {
      const status = this.editedItem.estadoHacienda;
      const finished = status === "ACEPTADO" || status === "RECHAZADO";
      
      this.imprimirValid = finished;
      this.reenviarValid = finished;
      this.verPDF = finished;
      this.verXMLFirmado = finished;
      this.verXMLRespuesta = finished;
      
      this.consultarEstadoValid = (status === "PROCESANDO");
      this.guardarValid = (this.editedIndex === -1); // Solo editable si es nueva
      this.incluirValid = (this.editedIndex === -1);
    },

    save() {
      this.snackValue = false;
      let me = this;
      this.visibleProgress = true;
      
      // Preparar datos para el backend
      const now = new Date();
      this.editedItem.fecha = now;
      this.editedItem.fechaHacienda = now;
      this.editedItem.contingenciaFecha = now;
      this.editedItem.cia = this.strCia;
      this.editedItem.usuario = this.user.id;
      this.editedItem.tipoFact = "08";
      this.editedItem.nombreTabla = "FacturasCompras";

      this.modelFactura.comprobante = this.editedItem;
      this.modelFactura.comprobanteDetalle = this.lineasDetalle;

      axios
        .post("api/Facturacion/insertComprobante", this.modelFactura)
        .then(function (response) {
          me.visibleProgress = false;
          me.respuestaHacienda = response.data;

          // Cargar respuesta en el objeto de edición
          me.editedItem.clavehacienda = me.respuestaHacienda.claveHacienda;
          me.editedItem.consHacReal = me.respuestaHacienda.consecutivoHacienda;
          me.editedItem.estadoHacienda = me.respuestaHacienda.eInvoiceStatus;
          me.editedItem.mensajeHacienda = me.respuestaHacienda.details;

          // Cambiar a modo detalle si era nueva
          if (me.editedIndex === -1) {
            me.editedIndex = 0; 
          }

          // Actualizar UI y abrir paneles de resultado
          me.updateUIVisibility();
          me.activePanels = [1, 2, 3]; // Detalle, Totales, Hacienda
          
          me.getData();
          me.snackText = "Comprobante procesado: " + me.editedItem.estadoHacienda;
          me.snackValue = true;
        })
        .catch(function (error) {
          me.visibleProgress = false;
          me.snackText = "Error al procesar comprobante";
          me.snackValue = true;
          console.log(error);
        });

      this.cancelarValid = false;
      this.guardarValid = false;
      this.incluirValid = true;
      this.btnAgregarArti = false;
      this.btnAgregarCliente = false;
    },

    saveDetalleArticulo() {
      if (this.detalleEditedIndex > -1) {
        Object.assign(
          this.lineasDetalle[this.detalleEditedIndex],
          this.detalleEditedItem
        );
      } else {
        this.lineasDetalle.push(this.detalleEditedItem);
      }
      this.close();

      let me = this;
      if (this.detalleEditedIndex > -1) {
        axios
          .post(
            "api/Facturacion/realizarCalculosComprobante",
            this.lineasDetalle
          )
          .then(function (response) {
            me.lineasDetalle = response.data.comprobanteDetalle;
            me.totales = response.data.comprobante;
            me.editedItem.totalIVADevuelto = 0; //validar esto

            me.editedItem.subTotal = me.totales.subtotal;
            me.editedItem.totalDescuentos = me.totales.totalDescuentos;
            me.editedItem.totalImpuesto = me.totales.totalImpuesto;
            me.editedItem.totalIva1 = me.totales.totalIva1;
            me.editedItem.totalIva2 = me.totales.totalIva2;
            me.editedItem.totalIva4 = me.totales.totalIva4;
            me.editedItem.totalIva13 = me.totales.totalIva13;
            me.editedItem.totalComprobante = me.totales.totalComprobante;

            me.editedItem.totalServGravados = me.totales.totalServGravados;
            me.editedItem.totalServExentos = me.totales.totalServExentos;
            me.editedItem.totalServExonerado = me.totales.totalServExonerado;
            me.editedItem.totalMercanciasGravadas =
              me.totales.totalMercanciasGravadas;
            me.editedItem.totalMercanciasExentas =
              me.totales.totalMercanciasExentas;
            me.editedItem.totalMercExonerada = me.totales.totalMercExonerada;
            me.editedItem.totalGravado = me.totales.totalGravado;
            me.editedItem.totalExento = me.totales.totalExento;
            me.editedItem.totalExonerado = me.totales.totalExonerado;
            me.editedItem.totalVenta = me.totales.totalVenta;
            me.editedItem.totalVentaNeta = me.totales.totalVentaNeta;
            me.editedItem.totalIVADevuelto = me.totales.totalIVADevuelto;
            me.editedItem.totalOtrosCargos = me.totales.totalOtrosCargos;
            me.editedItem.totalIva13 = me.totales.totalIva13;

            me.editedItem.totalIVADevueltoStr = me.totales.totalIVADevueltoStr; //validar esto
            me.editedItem.totalIva1Str = me.totales.totalIva1Str;
            me.editedItem.totalIva2Str = me.totales.totalIva2Str;
            me.editedItem.totalIva4Str = me.totales.totalIva4Str;
            me.editedItem.totalIva13Str = me.totales.totalIva13Str;
            me.editedItem.totalDescuentosStr = me.totales.totalDescuentosStr;
            me.editedItem.totalImpuestoStr = me.totales.totalImpuestoStr;
            me.editedItem.subtotalStr = me.totales.subtotalStr;
            me.editedItem.totalComprobanteStr = me.totales.totalComprobanteStr;
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        axios
          .post(
            "api/Facturacion/realizarCalculosComprobante",
            this.lineasDetalle
          )
          .then(function (response) {
            me.lineasDetalle = response.data.comprobanteDetalle;

            me.totales = response.data.comprobante;
            me.editedItem.totalIVADevuelto = 0; //validar esto
            me.editedItem.subTotal = me.totales.subtotal;
            me.editedItem.totalDescuentos = me.totales.totalDescuentos;
            me.editedItem.totalImpuesto = me.totales.totalImpuesto;
            me.editedItem.totalIva1 = me.totales.totalIva1;
            me.editedItem.totalIva2 = me.totales.totalIva2;
            me.editedItem.totalIva4 = me.totales.totalIva4;
            me.editedItem.totalIva13 = me.totales.totalIva13;
            me.editedItem.totalComprobante = me.totales.totalComprobante;

            me.editedItem.totalServGravados = me.totales.totalServGravados;
            me.editedItem.totalServExentos = me.totales.totalServExentos;
            me.editedItem.totalServExonerado = me.totales.totalServExonerado;
            me.editedItem.totalMercanciasGravadas =
              me.totales.totalMercanciasGravadas;
            me.editedItem.totalMercanciasExentas =
              me.totales.totalMercanciasExentas;
            me.editedItem.totalMercExonerada = me.totales.totalMercExonerada;
            me.editedItem.totalGravado = me.totales.totalGravado;
            me.editedItem.totalExento = me.totales.totalExento;
            me.editedItem.totalExonerado = me.totales.totalExonerado;
            me.editedItem.totalVenta = me.totales.totalVenta;
            me.editedItem.totalVentaNeta = me.totales.totalVentaNeta;
            me.editedItem.totalIVADevuelto = me.totales.totalIVADevuelto;
            me.editedItem.totalOtrosCargos = me.totales.totalOtrosCargos;
            me.editedItem.totalIva13 = me.totales.totalIva13;

            me.editedItem.totalIVADevueltoStr = me.totales.totalIVADevueltoStr; //validar esto
            me.editedItem.totalIva1Str = me.totales.totalIva1Str;
            me.editedItem.totalIva2Str = me.totales.totalIva2Str;
            me.editedItem.totalIva4Str = me.totales.totalIva4Str;
            me.editedItem.totalIva13Str = me.totales.totalIva13Str;
            me.editedItem.totalDescuentosStr = me.totales.totalDescuentosStr;
            me.editedItem.totalImpuestoStr = me.totales.totalImpuestoStr;
            me.editedItem.subtotalStr = me.totales.subtotalStr;
            me.editedItem.totalComprobanteStr = me.totales.totalComprobanteStr;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      this.cancelarValid = true;
      this.imprimirValid = false;
      this.reenviarValid = false;
      this.verPDF = false;
      this.verXMLFirmado = false;
      this.verXMLRespuesta = false;
      this.guardarValid = true;
      this.incluirValid = false;
      this.snackValue = false;
      this.panelResumen = [0];
      this.consultarEstadoValid = false;
    },

    recalcularTotales() {
      let me = this;
      if (this.lineasDetalle.length === 0) {
        me.editedItem.subtotalStr = "0.00";
        me.editedItem.totalDescuentosStr = "0.00";
        me.editedItem.totalImpuestoStr = "0.00";
        me.editedItem.totalComprobanteStr = "0.00";
        return;
      }

      axios
        .post("api/Facturacion/realizarCalculosComprobante", this.lineasDetalle)
        .then(function (response) {
          me.lineasDetalle = response.data.comprobanteDetalle;
          me.totales = response.data.comprobante;

          // Mapeo de totales al objeto principal
          me.editedItem.subTotal = me.totales.subtotal;
          me.editedItem.totalDescuentos = me.totales.totalDescuentos;
          me.editedItem.totalImpuesto = me.totales.totalImpuesto;
          me.editedItem.totalIva1 = me.totales.totalIva1;
          me.editedItem.totalIva2 = me.totales.totalIva2;
          me.editedItem.totalIva4 = me.totales.totalIva4;
          me.editedItem.totalIva13 = me.totales.totalIva13;
          me.editedItem.totalComprobante = me.totales.totalComprobante;
          
          me.editedItem.totalServGravados = me.totales.totalServGravados;
          me.editedItem.totalServExentos = me.totales.totalServExentos;
          me.editedItem.totalServExonerado = me.totales.totalServExonerado;
          me.editedItem.totalMercanciasGravadas = me.totales.totalMercanciasGravadas;
          me.editedItem.totalMercanciasExentas = me.totales.totalMercanciasExentas;
          me.editedItem.totalMercExonerada = me.totales.totalMercExonerada;
          me.editedItem.totalGravado = me.totales.totalGravado;
          me.editedItem.totalExento = me.totales.totalExento;
          me.editedItem.totalExonerado = me.totales.totalExonerado;
          me.editedItem.totalVenta = me.totales.totalVenta;
          me.editedItem.totalVentaNeta = me.totales.totalVentaNeta;
          me.editedItem.totalIVADevuelto = me.totales.totalIVADevuelto;
          me.editedItem.totalOtrosCargos = me.totales.totalOtrosCargos;

          // Mapeo de strings para visualización
          me.editedItem.totalIVADevueltoStr = me.totales.totalIVADevueltoStr;
          me.editedItem.totalIva1Str = me.totales.totalIva1Str;
          me.editedItem.totalIva2Str = me.totales.totalIva2Str;
          me.editedItem.totalIva4Str = me.totales.totalIva4Str;
          me.editedItem.totalIva13Str = me.totales.totalIva13Str;
          me.editedItem.totalDescuentosStr = me.totales.totalDescuentosStr;
          me.editedItem.totalImpuestoStr = me.totales.totalImpuestoStr;
          me.editedItem.subtotalStr = me.totales.subtotalStr;
          me.editedItem.totalComprobanteStr = me.totales.totalComprobanteStr;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    close() {
      this.snackValue = false;
      this.dialogArticulos = false;
      this.$nextTick(() => {
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.detalleEditedIndex = -1;
      });
    },

    limpiar() {
      this.snackValue = false;
    },

    deleteItem(item) {
      if (this.guardarValid) {
        this.detalleEditedIndex = this.lineasDetalle.indexOf(item);
        this.detalleEditedItem = Object.assign({}, item);
        this.dialogDelete = true;
      }
    },

    closed() {
      this.snackValue = false;
      this.showNewData = false;
      this.showNewDataArti = false;
      this.dialog = false;
      this.dialogArticulos = false;
      this.dialogBuscarArticulos = false;
    },

    selected(value) {
      this.cliente = Object.assign({}, value);
      this.showNewData = false;
      this.dialog = false;
      this.dialogArticulos = false;
      this.editedItem.clienteCod = this.cliente.codigo;
      this.editedItem.clienteNombre = this.cliente.nombre;
      this.editedItem.clienteCorreo = this.cliente.correo;
      this.editedItem.clienteCedula = this.cliente.cedula;
      this.editedItem.clienteAreaTel = this.cliente.areaTel;
      this.editedItem.clienteTelefono = this.cliente.telefono;
      this.editedItem.clienteNombreComercial = this.cliente.nombreComercial;
      this.getProvincias();
      this.editedItem.clienteProvincia = this.cliente.provincia;
      this.getCantones();
      this.editedItem.clienteCanton = this.cliente.canton;
      this.getDistritos();
      this.editedItem.clienteDistrito = this.cliente.distrito;
      this.getBarrios();
      this.editedItem.clienteBarrio = this.cliente.barrio;
      this.editedItem.clienteDireccion = this.cliente.direccion;
      this.editedItem.clienteTipoId = this.cliente.tipoId;
      
      // Abrir siguiente panel (Artículos)
      this.btnAgregarArti = true;
      this.activePanels = [0, 1];
    },

    selectedArticulos(value) {
      if (!value) return;
      const art = Object.assign({}, value);
      this.showNewDataArti = false;
      this.dialogBuscarArticulos = false;
      
      const newLine = {
        cia: this.strCia,
        factura: this.editedItem.codigoFact,
        tipoFact: "08",
        numLinea: this.lineasDetalle.length + 1,
        cantidad: 1,
        articulo: art.codigo,
        descripcion: art.nombre,
        unidad: art.unidad,
        monto: art.monto,
        descuento: 0,
        porcDescuento: 0,
        totalLinea: art.monto,
        sucursal: this.editedItem.sucursal,
        terminal: this.editedItem.terminal,
        tipoCodigo: "01",
        unidadMedidaComercial: "M2",
        impCodigo: art.codigoImp,
        impCodigoTarifa: art.codigoTarifa,
        impTarifa: art.tarifa,
        impuestosVentas: art.tarifa,
        tipoCambio: this.editedItem.tipoCambio,
        tipoProducto: art.tipoArt,
        moneda: this.editedItem.moneda,
        cabys: art.cabys,
        registroMedicamento: art.registroMedicamento,
        formaFarmaceutica: art.formaFarmaceutica,
        totalLineaStr: (art.monto).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' }),
        montoStr: (art.monto).toLocaleString('es-CR', { style: 'currency', currency: 'CRC' })
      };

      this.lineasDetalle.push(newLine);
      this.activePanels = [1, 2]; // Asegurar que el panel de detalle esté abierto
      this.recalcularTotales();
      this.closed();
    },

    cerrar() {
      this.snackValue = false;
      this.drawerForm = false;
      this.visibleProgress = false;
      this.dialog = false;
      this.dialogArticulos = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.valid = false;
        this.cancelarValid = false;
        this.imprimirValid = false;
        this.reenviarValid = false;
        this.verPDF = false;
        this.verXMLFirmado = false;
        this.verXMLRespuesta = false;
        this.guardarValid = false;
        this.incluirValid = true;
        this.consultarEstadoValid = false;
        this.panelResumen = [];
        this.panel = [];
        this.activePanels = [];
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.lineasDetalle = [];
        this.btnAgregarArti = false;
        this.btnAgregarCliente = false;
      });
    },

    onImageChange(ev) {
      this.tempFile = ev;
      this.editedItem.certificado = ev.name;
    },

    getCodigoFactura() {
      let me = this;
      axios
        .get(
          "api/Facturacion/getComprobanteConsInterno?cia=" +
            this.strCia +
            "&docNombre=FacturasCompras&tipoDoc=FC"
        )
        .then(function (response) {
          me.editedItem.codigoFact = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getFechaActual() {
      let me = this;
      axios
        .get("api/Facturacion/getFechaActualString")
        .then(function (response) {
          me.fecha = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    validarLicencia() {
      let me = this;
      axios
        .get("api/General/licenciaValidar?cia=" + this.strCia)
        .then(function (response) {
          me.licenciaValida = response.data;
          if (me.licenciaValida.valido) {
            me.incluir();
          } else {
            me.snackText = me.licenciaValida.motivo;
            me.snackValue = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    incluir() {
      this.snackValue = false;
      this.drawerForm = true;
      this.activePanels = [0, 1];
      
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.getCodigoFactura();
        this.cancelarValid = true;
        this.imprimirValid = false;
        this.reenviarValid = false;
        this.verPDF = false;
        this.verXMLFirmado = false;
        this.verXMLRespuesta = false;
        this.guardarValid = true;
        this.incluirValid = false;
        this.consultarEstadoValid = false;
        this.getCia();
        this.getMonedas();
        this.getActividades();
        this.getCondicionVenta();
        this.getMedioPago();
        this.getSucursales();
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.lineasDetalle = [];
        this.editedItem.estadoHacienda = "PENDIENTE";
        this.panel = [0];
        this.btnAgregarArti = false;
        this.btnAgregarCliente = true;
        this.getFechaActual();
      });
    },
  },
};
</script>

<style scoped>
.modern-table { background: transparent !important; }

/* Tabla principal */
.clickable-rows >>> tbody tr { cursor: pointer; }
.clickable-rows >>> tbody tr:hover {
  background-color: rgba(5, 150, 105, 0.05) !important;
}

.modern-table >>> thead th {
  background-color: #f8fafc !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  letter-spacing: 0.06em;
  border-bottom: 2px solid #f1f5f9 !important;
}
.theme--dark .modern-table >>> thead th {
  background-color: #1e293b !important;
  color: #94a3b8 !important;
  border-bottom: 2px solid #334155 !important;
}

/* Botones de acción */
.action-btn { background: rgba(5, 150, 105, 0.05); transition: all 0.2s; }
.action-btn:hover { background: rgba(5, 150, 105, 0.15); transform: scale(1.1); }

/* Drawer */
.form-drawer { background: #ffffff !important; }
.theme--dark .form-drawer { background: #0f172a !important; }

/* Drawer header - emerald gradient */
.drawer-header {
  height: 60px;
  border-radius: 0 0 0 20px;
  background: linear-gradient(135deg, #047857 0%, #059669 60%, #10b981 100%) !important;
}

/* Expansion panels */
.modern-panels >>> .v-expansion-panel { border: 1px solid rgba(0,0,0,0.07) !important; border-radius: 4px !important; }
.modern-panels >>> .v-expansion-panel--active {
  border: 1px solid rgba(5, 150, 105, 0.3) !important;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.07) !important;
  margin-bottom: 2px !important;
  border-radius: 4px !important;
}
.modern-panels >>> .v-expansion-panel + .v-expansion-panel {
  margin-top: 2px !important;
}
.modern-panels >>> .v-expansion-panel-header {
  min-height: 40px !important;
  padding: 0 12px !important;
  font-size: 0.875rem !important;
  border-radius: 4px !important;
}
.modern-panels >>> .v-expansion-panel-content__wrap {
  padding: 4px 4px 6px !important;
}

/* Inputs compactos */
.compact-input >>> input {
  padding: 0px !important;
  text-align: center !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
  height: 28px !important;
  min-width: 40px !important;
  max-width: 60px !important;
}
.compact-input >>> .v-input__slot {
  padding: 0 4px !important;
  border-radius: 8px !important;
  min-height: 28px !important;
}
.compact-input >>> .v-input__control { min-height: 38px !important; }
.compact-input >>> input::-webkit-outer-spin-button,
.compact-input >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}
.theme--dark .compact-input >>> input { color: #ffffff !important; }
.theme--light .compact-input >>> input { color: #000000 !important; }

.right-input >>> input { text-align: right; font-weight: bold; }
.edit-table >>> td { height: 40px !important; }

/* Visor de documentos */
.doc-viewer-toolbar {
  background: linear-gradient(135deg, #047857 0%, #059669 60%, #10b981 100%);
  min-height: 44px;
  flex-shrink: 0;
}

/* ===== FCE DESIGN SYSTEM ===== */
.fce-container {
  background-color: #f1f5f9;
  min-height: 100vh;
}
.theme--dark.fce-container {
  background-color: #0f172a;
}
.fce-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.theme--dark .fce-toolbar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.07) !important;
}
.fce-toolbar-title {
  font-size: 0.95rem !important;
  letter-spacing: 1.5px;
}
.fce-btn {
  border-radius: 4px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 0.75rem !important;
}
.fce-table-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.fce-table { background: transparent !important; }
.fce-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.fce-table >>> tbody tr { cursor: pointer; }
.fce-table >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.05) !important;
}
.theme--dark .fce-table >>> tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}
.fce-search >>> .v-input__slot {
  border-radius: 4px !important;
}
.fce-drawer >>> .v-navigation-drawer__content {
  background-color: #ffffff !important;
}
.theme--dark .fce-drawer >>> .v-navigation-drawer__content {
  background-color: #0f172a !important;
}
.fce-drawer-header {
  background-color: #37474f;
  flex-shrink: 0;
}
.fce-drawer-header--dark {
  background-color: #263238 !important;
}
.fce-drawer-footer {
  background-color: #f8fafc;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.fce-drawer-footer--dark {
  background-color: #1e293b !important;
  border-top: 1px solid rgba(255, 255, 255, 0.07) !important;
}
</style>